exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.SystemUser[data-v-b87289cc] {\r\n    color: #CC9966\n}\n.TjkUser[data-v-b87289cc] {\r\n    color: #CCCC99\n}\n.TicketTrigger[data-v-b87289cc] {\r\n    color: #336699\n}\n.item_1[data-v-b87289cc] {\r\n    width : 50%;\r\n    float: left;\n}\n._left_1[data-v-b87289cc] {\r\n    padding-top: 5px;\r\n    display : inline-block;\r\n    width: 50px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b87289cc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketUser.vue
// module id = 707
// module chunks = 75